import React from 'react';

export type IconProps = {
  isFocused: boolean;
};
export const SettingIcon = ({ isFocused }: IconProps) => {
  return (
    <svg width="26" height="33" viewBox="0 0 26 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.42578 21.8846C7.42578 19.8384 9.08453 18.1797 11.1307 18.1797H14.3063C16.3525 18.1797 18.0112 19.8384 18.0112 21.8846V29.8237C18.0112 31.5775 16.5895 32.9993 14.8356 32.9993H10.6014C8.84756 32.9993 7.42578 31.5775 7.42578 29.8237V21.8846Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M6.32475 1.20696C6.62547 0.476644 7.33721 0 8.12701 0H17.2109C18.0007 0 18.7124 0.476642 19.0131 1.20696L24.3071 14.0638C24.814 15.2947 23.9642 16.6605 22.635 16.7338C15.6824 17.1173 9.72652 17.0815 2.72467 16.7204C1.38925 16.6515 0.529586 15.2809 1.03872 14.0445L6.32475 1.20696Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
    </svg>
  );
};

export const AccessIcon = ({ isFocused }: IconProps) => {
  return (
    <svg width="26" height="32" viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.9714 4.29968C16.9714 6.41975 16.2037 8.13842 13.1327 8.13842C10.0617 8.13842 9.29395 6.41975 9.29395 4.29968C9.29395 2.1796 10.0617 0.460938 13.1327 0.460938C16.2037 0.460938 16.9714 2.1796 16.9714 4.29968Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M8.66309 9.85031C11.8638 9.69327 12.9944 9.84995 17.3757 9.7583C16.7106 14.6943 15.99 17.6832 17.3757 21.8807H8.89009C9.19783 17.083 8.96031 14.5229 8.66309 9.85031Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M12.9947 9.84415C14.3604 9.8409 18.2716 9.15614 23.6099 8.29944C24.6286 8.13596 25.5826 8.84137 25.7269 9.863C25.8637 10.8317 25.2214 11.7408 24.2606 11.9246C20.5608 12.6323 18.0021 12.9686 13.8408 13.3007L12.9947 9.84415Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M16.5288 17.3773C19.0366 21.3676 20.0041 23.6568 21.5326 26.9996C21.9674 27.9505 21.5823 29.0799 20.6514 29.556C19.6226 30.0821 18.369 29.5949 17.9376 28.5229C16.6693 25.3712 15.4603 23.0041 12.9311 19.2173L16.5288 17.3773Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M13.5557 18.5181C11.1682 22.5264 9.98927 25.1115 8.94848 28.8534C8.6178 30.0423 7.33234 30.7039 6.19127 30.2341C5.20978 29.8299 4.70962 28.7314 5.06315 27.7305C6.43204 23.8552 7.57877 21.1825 9.6379 16.9048L13.5557 18.5181Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M12.0323 13.5898L1.79603 11.6322C0.804295 11.4426 0.154083 10.4849 0.34374 9.49313C0.530648 8.51577 1.46483 7.86731 2.44329 8.04837C6.72578 8.84087 11.2688 9.84455 14.4385 9.84473C18.0479 9.84494 12.0323 13.5898 12.0323 13.5898Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
    </svg>
  );
};

export const WhatIcon = ({ isFocused }: IconProps) => {
  return (
    <svg width="27" height="32" viewBox="0 0 27 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.0526894 12.1065C0.0245019 11.5145 0.514405 11.0282 1.10616 11.0599C11.9287 11.6413 15.0731 11.6446 25.8935 11.0603C26.4854 11.0283 26.9755 11.5148 26.9473 12.1068L26.1674 28.4851C26.0737 30.4528 24.451 32 22.4811 32H13.5H4.51892C2.54897 32 0.926323 30.4528 0.832622 28.4851L0.0526894 12.1065Z"
        fill={isFocused ? '#ffffff' : '#4C3B51'}
      />
      <path
        d="M5 11C5.00207 -0.704082 21.5146 -1.29244 22 10.9991"
        stroke={isFocused ? '#ffffff' : '#4C3B51'}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ExpandIcon = ({ isFocused }: IconProps) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33789 9.61768L12.3379 15.6177L18.3379 9.61768"
        stroke={isFocused ? '#ffffff' : '#4C3B51'}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
